module.exports = __webpack_public_path__ + "static/media/ServCo Logo Full_1715288377335.e68edd88.jpg";